// extracted by mini-css-extract-plugin
export var active = "_4a-7";
export var container = "_4a-0";
export var evenWidth = "_4a-4";
export var large = "_4a-5";
export var outlet = "_4a-8";
export var slide = "_4a-2";
export var small = "_4a-6";
export var tab = "_4a-3";
export var tabs = "_4a-1";